

export const initialFilter = {
  sortOrder: "asc",
  sortField: "id",
  pageNumber: 1,
  pageSize: 10
};
